module.exports = __webpack_public_path__ + "img/feature_buy_my.28aa190e.png";